// extracted by mini-css-extract-plugin
export default {"container_background":"contact_container_background__OB0J8","contenedor_staff":"contact_contenedor_staff__TxWoV"};